import HeaderSignOut from "../../../../components/headers/HeaderSignOut";
import InputEmailStep from "./0_InputEmailStep";
import ConfirmEmailStep from "./1_ConfirmEmailStep";
import { Stepper, Step, StepLabel, Box, Container } from "@mui/material";
import React, { useState } from "react";

const stepNames = ["メールアドレス入力", "認証コード入力"];

const PhoneNumChangeStepperPage: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <InputEmailStep onNext={handleNextStep} />;
      case 1:
        return <ConfirmEmailStep />;
      default:
        return null;
    }
  };

  return (
    <>
      <HeaderSignOut />
      <Container maxWidth="sm">
        <Box mt={5}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {stepNames.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box mt={4}>{renderStepContent(activeStep)}</Box>
        </Box>
      </Container>
    </>
  );
};

export default PhoneNumChangeStepperPage;
